// Constants
import { GIL_API_CHANNEL } from 'constants/api.constants';
// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const LOG_SERVICE_CONFIGURATION = {
  ...GIL_API_CHANNEL,
  endpoint: 'gil-api-mng-amz-ldg/v1/checkout/orders/:checkoutId/log',
  pathParams: {
    checkoutId: getCheckoutIdFromUrl(),
  },
};

export { LOG_SERVICE_CONFIGURATION };
